import templateUrl from 'emun.salesrep/salesrep-sales-goals-ly-chart.htm';
class SalesRepSalesGoalsLYChartController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
		let $ctrl = this;
		if (!$ctrl.mode) { $ctrl.mode = 'list'; }
		$ctrl.chartLoaded = false;
		this.quarterSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.ytdSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.monthSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.quarterSalesLY = {
			total: 0,
			count: 0
		};
		this.ytdSalesLY = {
			total: 0,
			count: 0
		};
		this.monthSalesLY = {
			total: 0,
			count: 0
		};

		this.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true,
				labels: {
					boxWidth: 5,
					fontSize: 10
				}
			},
			elements: {
				rectangle: {
					borderWidth: 1
				}
			},
			scales: {
				yAxes: [{
					display: true,
					ticks: {
						callback: function (value, index, values) {
							return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						},
						fontSize: 11
					}
				}]
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label;
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						//                        return label + ': ' + $filter('currency')(datasetLabel);
					}
				}
			},
		};

		//      var context = this.context || 'rep';

		//var filter = "SalesRepID";
		//var groupBy = "SalesRepID";
		//if (context == 'manager') {
		//	filter = "ManagerId";
		//} else if (context == 'vendor') {
		//	filter = "VendorId";
		//	groupBy = "VendorId";
		//}

		var context = $ctrl.context || 'rep';
		var repFilter = "";
		var groupBy = "VendorId";
		if (context !== 'executive') {
			var filterType = "SalesRepID";
			if (context === 'manager') {
				filterType = 'ManagerId';
			} else if (context === 'vendor') {
				filterType = 'VendorId';
				groupBy = "VendorId";
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
			if ($ctrl.repGroup) {
				if ($ctrl.repGroup !== "ALL") repFilter = repFilter + "&RepGroupName=" + $ctrl.repGroup;
			}
		}
		if ($ctrl.insideSales === 'true') {
			repFilter = repFilter + "&IsInsideSales=true";
		}

		this.salesQuery = createAutoQuery({
			url: 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear&GroupBy=' + groupBy + repFilter,
			autoLoad: true,
			beforeLoading: function (args) {
				const $ctrl = this;
				if (args.request.RepGroupName === "ALL") delete args.request.RepGroupName;
			},
			take: 10000,
			onLoaded: function (args) {
				if (args.count > 0) {
					args.results.forEach(function (res) {
						$ctrl.monthSales.total += res.sumTotalSalesMonthToDate;
						$ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
						$ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
						$ctrl.monthSalesLY.total += res.sumTotalSalesMonthToDateLastYear;
						$ctrl.quarterSalesLY.total += res.sumTotalSalesQuarterToDateLastYear;
						$ctrl.ytdSalesLY.total += res.sumTotalSalesYearToDateLastYear;

					});

					var percent = Math.round(($ctrl.monthSales.total / $ctrl.monthSalesLY.total) * 100);
					if ($ctrl.monthSalesLY.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.monthSales.percent = 100 - percent;
						$ctrl.monthSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.monthSales.percent = percent - 100;
						$ctrl.monthSales.trend = 'up';
					} else {
						$ctrl.monthSales.percent = 100;
						$ctrl.monthSales.trend = 'neutral';
					}

					percent = Math.round(($ctrl.quarterSales.total / $ctrl.quarterSalesLY.total) * 100);
					if ($ctrl.quarterSalesLY.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.quarterSales.percent = 100 - percent;
						$ctrl.quarterSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.quarterSales.percent = percent - 100;
						$ctrl.quarterSales.trend = 'up';
					} else {
						$ctrl.quarterSales.percent = 100;
						$ctrl.quarterSales.trend = 'neutral';
					}

					percent = Math.round(($ctrl.ytdSales.total / $ctrl.ytdSalesLY.total) * 100);
					if ($ctrl.ytdSalesLY.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.ytdSales.percent = 100 - percent;
						$ctrl.ytdSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.ytdSales.percent = percent - 100;
						$ctrl.ytdSales.trend = 'up';
					} else {
						$ctrl.ytdSales.percent = 100;
						$ctrl.ytdSales.trend = 'neutral';
					}

					$ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
					$ctrl.goalChartSeries = ["Sales", "Goal"];

					$ctrl.goalChartData = [];
					$ctrl.tableData = [];
					var today = new Date();
					$ctrl.loadGoalChartData = function (args) {
						$ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
						$ctrl.goalChartSeries = ["Sales", "Goal", "Last Year"];
						$ctrl.goalChartData = [];
						var flags = [];

						var goalSeriesData = [Math.round($ctrl.monthSales.total), Math.round($ctrl.quarterSales.total), Math.round($ctrl.ytdSales.total)];
						$ctrl.goalChartData.push(goalSeriesData);
						$ctrl.tableData.push({
							label: 'This Year',
							mtd: Math.round($ctrl.monthSales.total),
							mtdpercent: $ctrl.monthSales.percent,
							mtdtrend: $ctrl.monthSales.trend,
							qtd: Math.round($ctrl.quarterSales.total),
							qtdpercent: $ctrl.quarterSales.percent,
							qtdtrend: $ctrl.quarterSales.trend,
							ytd: Math.round($ctrl.ytdSales.total),
							ytdpercent: $ctrl.ytdSales.percent,
							ytdtrend: $ctrl.ytdSales.trend,
						});

						var qtrGoal = 0;
						var qtr1Goal = 0;
						var qtr2Goal = 0;
						var qtr3Goal = 0;
						var qtr4Goal = 0;
						var monthGoal = 0;
						var totalGoal = 0;
						var thisMonth = moment().month() + 1;
						var nextMonth = moment().month() + 2;
						args.results.forEach(function (r) {
							var month = r.month; //moment(r.month).month() + 1;

							//this is for the inside sales specific data
							if ($ctrl.insideSales) {
								r.goal = r.actualBooked;
							}
							if (month === 1 || month === 2 || month === 3) {
								qtr1Goal += r.goal;
							} else if (month === 4 || month === 5 || month === 6) {
								qtr2Goal += r.goal;
							} else if (month === 7 || month === 8 || month === 9) {
								qtr3Goal += r.goal;
							} else if (month === 10 || month === 11 || month === 12) {
								qtr4Goal += r.goal;
							}
							if (month === thisMonth) {
								monthGoal = monthGoal += r.goal;
							}
							totalGoal += r.goal;
						});
						if (moment().quarter() === 1) {
							qtrGoal = Math.round(qtr1Goal);
						} else if (moment().quarter() === 2) {
							qtrGoal = Math.round(qtr2Goal);
						} else if (moment().quarter() === 3) {
							qtrGoal = Math.round(qtr3Goal);
						} else if (moment().quarter() === 4) {
							qtrGoal = Math.round(qtr4Goal);
						}
						goalSeriesData = [Math.round(monthGoal), qtrGoal, Math.round(totalGoal)];
						$ctrl.goalChartData.push(goalSeriesData);

						var mtdGoalPercent = 0;
						var mtdGoalTrend = 0;
						var qtdGoalPercent = 0;
						var qtdGoalTrend = 0;
						var ytdGoalPercent = 0;
						var ytdGoalTrend = 0;

						var percent = Math.round(($ctrl.monthSales.total / monthGoal) * 100);
						if (monthGoal === 0) { percent = 100; }
						if (percent < 100) {
							mtdGoalPercent = 100 - percent;
							mtdGoalTrend = 'down';
						} else if (percent > 100) {
							mtdGoalPercent = percent - 100;
							mtdGoalTrend = 'up';
						} else {
							mtdGoalPercent = 100;
							mtdGoalTrend = 'neutral';
						}
						percent = Math.round(($ctrl.quarterSales.total / qtrGoal) * 100);
						if (qtrGoal === 0) { percent = 100; }
						if (percent < 100) {
							qtdGoalPercent = 100 - percent;
							qtdGoalTrend = 'down';
						} else if (percent > 100) {
							qtdGoalPercent = percent - 100;
							qtdGoalTrend = 'up';
						} else {
							qtdGoalPercent = 100;
							qtdGoalTrend = 'neutral';
						}

						percent = Math.round(($ctrl.ytdSales.total / totalGoal) * 100);
						if (totalGoal === 0) { percent = 100; }
						if (percent < 100) {
							ytdGoalPercent = 100 - percent;
							ytdGoalTrend = 'down';
						} else if (percent > 100) {
							ytdGoalPercent = percent - 100;
							ytdGoalTrend = 'up';
						} else {
							ytdGoalPercent = 100;
							ytdGoalTrend = 'neutral';
						}
						$ctrl.tableData.push({
							label: 'Goal',
							mtd: Math.round(monthGoal),
							mtdpercent: mtdGoalPercent,
							mtdtrend: mtdGoalTrend,
							qtd: Math.round(qtrGoal),
							qtdpercent: qtdGoalPercent,
							qtdtrend: qtdGoalTrend,
							ytd: Math.round(totalGoal),
							ytdpercent: ytdGoalPercent,
							ytdtrend: ytdGoalTrend,
						});

						var goalSeriesDataLY = [Math.round($ctrl.monthSalesLY.total), Math.round($ctrl.quarterSalesLY.total), Math.round($ctrl.ytdSalesLY.total)];
						$ctrl.goalChartData.push(goalSeriesDataLY);
						$ctrl.tableData.push({
							label: 'Last Year',
							mtd: Math.round($ctrl.monthSalesLY.total),
							qtd: Math.round($ctrl.quarterSalesLY.total),
							ytd: Math.round($ctrl.ytdSalesLY.total)
						});
						$ctrl.chartLoaded = true;

					};

					var RMGoalsQuery = 'QueryRepMonthlyGoals.json?';
					if (!$ctrl.insideSales) {
						RMGoalsQuery = RMGoalsQuery + repFilter + '&IsInsideSales=false';
					} else {
						RMGoalsQuery = RMGoalsQuery + repFilter + '&FromActualBooked=0';
					}

					$ctrl.salesGoals = createAutoQuery({
						url: RMGoalsQuery,
						take: 10000,
						autoLoad: true,
						onLoaded: args => { $ctrl.loadGoalChartData(args); }
					});
				}
			}
		});

	}
}

let SalesRepSalesGoalsLYChart = {
	bindings: {
		rep: '<',
		repGroup: '@',
		repGroupId: '@',
		context: '@',
		insideSales: '@'
	},
	//require:{
	//    container: '^salesrepDashboard'
	//},
	controller: SalesRepSalesGoalsLYChartController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SalesRepSalesGoalsLYChart;